import React from "react";

import { Field } from "formik";
import * as constants from "../constants";
import { FormAutocomplete } from "../../../../../components/ui";

interface IProps {
  disabled: boolean;
}
const ProvinceAutocomplete: React.FC<IProps> = ({ disabled }) => (
  <Field
    options={constants.PROVINCE_OPTIONS}
    name="state"
    label="Province"
    component={FormAutocomplete}
    disabled={disabled}
  />
);

export default ProvinceAutocomplete;
